import { z } from 'zod';

/** ADR-0050 / BR-PRD-57..62 — taxonomia global de plataforma. */

const TaxonomySlugSchema = z
  .string()
  .trim()
  .min(1)
  .max(100)
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/);

export const CatalogCategoryIdParamsSchema = z.looseObject({
  id: z.uuid(),
});

export const CreateCatalogCategoryBodySchema = z.looseObject({
  name: z.string().trim().min(1).max(255),
  slug: TaxonomySlugSchema.optional(),
  parentId: z.uuid().nullable().optional(),
});

export const RenameCatalogCategoryBodySchema = z.looseObject({
  name: z.string().trim().min(1).max(255),
});

export const ChangeCatalogCategorySlugBodySchema = z.looseObject({
  slug: TaxonomySlugSchema,
});

export const MoveCatalogCategoryBodySchema = z.looseObject({
  parentId: z.uuid().nullable(),
});

export const ArchiveCatalogCategoryBodySchema = z.preprocess(
  (value) => value ?? {},
  z.looseObject({
    reason: z.string().trim().max(500).optional(),
  }),
);

export const ListCatalogCategoryTreeQuerySchema = z.looseObject({
  includeArchived: z
    .union([z.literal('true'), z.literal('false'), z.boolean()])
    .optional()
    .transform((value) => value === true || value === 'true'),
});

export const CatalogCategoryBreadcrumbItemSchema = z.looseObject({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
});

export const CatalogCategoryResponseSchema = z.looseObject({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
  parentId: z.uuid().nullable(),
  depth: z.number().int().min(1).max(3),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
  deletedAt: z.iso.datetime().nullable(),
  deletedByUserId: z.uuid().nullable(),
  deleteReason: z.string().nullable(),
});

export const CatalogCategoryTreeNodeSchema = CatalogCategoryResponseSchema.extend({
  breadcrumb: z.array(CatalogCategoryBreadcrumbItemSchema),
});

export const CatalogCategoryTreeResponseSchema = z.looseObject({
  items: z.array(CatalogCategoryTreeNodeSchema),
});

export type CatalogCategoryIdParams = z.infer<typeof CatalogCategoryIdParamsSchema>;
export type CreateCatalogCategoryBody = z.infer<typeof CreateCatalogCategoryBodySchema>;
export type RenameCatalogCategoryBody = z.infer<typeof RenameCatalogCategoryBodySchema>;
export type ChangeCatalogCategorySlugBody = z.infer<typeof ChangeCatalogCategorySlugBodySchema>;
export type MoveCatalogCategoryBody = z.infer<typeof MoveCatalogCategoryBodySchema>;
export type ArchiveCatalogCategoryBody = z.infer<typeof ArchiveCatalogCategoryBodySchema>;
export type ListCatalogCategoryTreeQuery = z.infer<typeof ListCatalogCategoryTreeQuerySchema>;
export type CatalogCategoryBreadcrumbItem = z.infer<typeof CatalogCategoryBreadcrumbItemSchema>;
export type CatalogCategoryResponse = z.infer<typeof CatalogCategoryResponseSchema>;
export type CatalogCategoryTreeNode = z.infer<typeof CatalogCategoryTreeNodeSchema>;
export type CatalogCategoryTreeResponse = z.infer<typeof CatalogCategoryTreeResponseSchema>;
